import service from "@/utils/http.js";

export const getList = (current, size, params) => {
  return service({
    url: '/api/blade-desk/overseasEducation/list',
    method: 'get',
    params: {
      ...params,
      current,
      size,
    }
  })
}

export const getDetail = (id) => {
  return service({
    url: '/api/blade-desk/overseasEducation/detail',
    method: 'get',
    params: {
      id
    }
  })
}

